<template>
  <div class="c-input-counter">
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle class="underlay" cx="50%" cy="50%" r="17.5" stroke="#DDE2E9" stroke-width="3"></circle>
      <circle
        class="circle"
        :style="counterCircle"
        cx="50%"
        cy="50%"
        r="17.5"
        stroke="#005eb8"
        stroke-width="3"
      ></circle>
    </svg>
    <span class="c-input-counter__count" v-if="value">{{max - value.length}}</span>
    <span class="c-input-counter__count" v-else>{{max}}</span>
  </div>
</template>

<script>
export default {
  name: 'input-counter',

  props: {
    value: String,
    max: Number,
  },

  data() {
    return {
      percentageComplete: 0,
    };
  },

  computed: {
    counterCircle() {
      const styleObj = {
        strokeDashoffset: 110,
        strokeDasharray: 110,
      };

      if (this.percentageComplete) {
        styleObj.strokeDashoffset =
          110 - (this.percentageComplete + this.percentageComplete * 0.1);
      }

      if (this.percentageComplete >= 75) {
        styleObj.stroke = 'orange';
      }

      if (this.percentageComplete >= 95) {
        styleObj.stroke = 'red';
      }

      return styleObj;
    },
  },

  watch: {
    value(value) {
      const vm = this;
      this.percentageComplete = Math.floor((vm.value.length / vm.max) * 100);
    },
  },
};
</script>

<style lang="scss">
.c-input-counter {
  position: absolute;
  bottom: 12px;
  right: 12px;

  svg {
    fill: none;
    transform: rotate(-90deg);
    width: 30px;
    height: 30px;
  }

  .circle {
    transition: all 0.2s 0s;
  }

  &__count {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    font-size: 12px;
    line-height: 30px;
    color: #c9ced4;
    text-align: center;
    vertical-align: middle;
  }
}
</style>
